<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="video-detail relative h-screen bg-black">
    <video-player
      v-if="dynamicVideo"
      ref="videoPlayerRef"
      :src="dynamicVideo.url"
      :poster="dynamicVideo.firstFrameUrl"
      :height="videoHeight"
    ></video-player>
    <div class="absolute right-3 top-1/3 z-10 flex w-8">
      <open-app-btn :extinfo="extinfo">
        <component :is="'style'">
          .video-operate-btn { display: flex; align-items: center; flex-direction: column;
          color: #c9c9c9; margin-bottom: 16px; } .video-operate-btn-img { width:
          {{ rootRem * 2 }}px; }
        </component>
        <div class="video-operate-btn">
          <img
            class="video-operate-btn-img"
            src="@/assets/images/videoDetail/video-like.png"
            alt="点赞"
          />
          <span>{{ dynamicContent?.likeCount || 0 }}</span>
        </div>
        <div class="video-operate-btn">
          <img
            class="video-operate-btn-img"
            src="@/assets/images/videoDetail/video-collect.png"
            alt="收藏"
          />
          <span>&nbsp;</span>
        </div>
        <div class="video-operate-btn">
          <img
            class="video-operate-btn-img"
            src="@/assets/images/videoDetail/video-comment.png"
            alt="评论"
          />
          <span>{{ dynamicContent?.commentCount || 0 }}</span>
        </div>
        <div class="video-operate-btn">
          <img
            class="video-operate-btn-img"
            src="@/assets/images/videoDetail/video-share.png"
            alt="分享"
          />
          <span>&nbsp;</span>
        </div>
      </open-app-btn>
    </div>
    <div class="absolute bottom-20 left-3.5 z-0 w-4/5">
      <open-app-btn :extinfo="extinfo">
        <component :is="'style'">
          .video-user-info { display: flex; align-items: center; gap:
          {{ rootRem * 0.75 }}px; font-size: {{ rootRem * 0.875 }}px; color: #fff; }
          .video-user-avatar { width: {{ rootRem * 2.5 }}px; height:
          {{ rootRem * 2.5 }}px; border-radius: 50%; } .video-user-subscribe { height:
          {{ rootRem * 1.25 }}px; width: {{ rootRem * 3 }}px; border-radius: 9999px;
          text-align: center; background-image: linear-gradient(to right, #EF4243,
          #FA7419); font-size: {{ rootRem * 0.75 }}px; line-height:
          {{ rootRem * 1.25 }}px; }
        </component>
        <div class="video-user-info">
          <img
            class="video-user-avatar"
            :src="dynamicUser?.head || VITE_DEFAULT_AVATAR"
            :alt="dynamicUser?.nickName"
          />
          <span>{{ dynamicUser?.nickName }}</span>
          <div class="video-user-subscribe">关注</div>
        </div>
      </open-app-btn>
      <van-config-provider :theme-vars="{ textEllipsisActionColor: '#999999' }">
        <van-text-ellipsis
          v-if="dynamicContent?.content"
          class="mt-1 text-justify text-white"
          :content="dynamicContent.content"
          expand-text="展开全文"
          collapse-text="收起"
          rows="2"
        />
      </van-config-provider>
    </div>
    <comment-operate
      :extinfo="extinfo"
      :like-num="dynamicContent?.likeCount || 0"
      theme="dark"
    ></comment-operate>
    <van-popup
      v-model:show="contentVisible"
      :overlay="false"
      position="bottom"
      :style="{ height: popupHeight }"
    >
      <div
        class="relative m-auto h-full max-w-screen-sm overflow-y-auto rounded-t bg-white pb-8"
      >
        <div class="sticky top-0 flex justify-end bg-white p-4">
          <img
            class="h-4 w-4 cursor-pointer"
            src="@/assets/images/videoDetail/close.png"
            @click="contentVisible = false"
          />
        </div>
        <div class="bg-[#f6f6f6] p-4">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <img
                class="h-8 w-8 rounded-full sm:h-12 sm:w-12"
                :src="dynamicUser?.head || VITE_DEFAULT_AVATAR"
                :onerror="'this.src=' + VITE_DEFAULT_AVATAR"
                :alt="dynamicUser?.nickName"
              />
              <div class="text-sm text-[#666]">{{ dynamicUser?.nickName }}</div>
              <div class="author-box">作者</div>
            </div>
            <open-app-btn :extinfo="extinfo">
              <component :is="'style'">
                .comment-like { display: flex; align-items: center; gap:
                {{ rootRem * 0.5 }}px; font-size: {{ rootRem * 0.875 }}px; color: #333;}
                .comment-like-img { width: {{ rootRem * 0.875 }}px; height:
                {{ rootRem * 0.875 }}px; }
              </component>
              <div class="comment-like">
                <img
                  src="@/assets/images/comment/comment-item-like.png"
                  class="comment-like-img"
                />
                <span>{{ dynamicContent?.likeCount }}</span>
              </div>
            </open-app-btn>
          </div>
          <div
            class="mt-2 whitespace-pre-wrap pl-10 text-justify text-sm leading-relaxed text-[#333] sm:pl-[3.75rem]"
          >
            <div
              v-if="dynamicContent?.title"
              class="color-[#333] text-justify font-semibold leading-relaxed"
            >
              {{ dynamicContent.title }}
            </div>
            <span v-if="subjectsText" class="text-[#83C4EA]" v-html="subjectsText"></span>
            <span class="break-all text-[#333]">{{ textContent }}</span>
            <div class="mt-2 text-xs text-[#999]">
              {{ getLatesMinutes(dynamicContent?.publishTime || '') }}
            </div>
          </div>
        </div>
        <comment-list :divider="false" />
      </div>
    </van-popup>
  </section>
</template>

<script setup lang="ts">
import { getLatesMinutes } from '@/utils';
import { useRem } from '@/utils/hooks';

defineOptions({ name: 'VideoDetail' });

const { VITE_DEFAULT_AVATAR } = import.meta.env;
const dynamicUser = inject<Ref<Dynamic.DynamicUser>>('dynamicUser');
const dynamicVideos = inject<Ref<Dynamic.DynamicVideo[]>>('dynamicVideos', ref([]));
const dynamicContent = inject<Dynamic.DynamicContentProps>('dynamicContent');
const extinfo = inject<Ref<string>>('extinfo', ref(''));
const dynamicSubjects = inject<Ref<Dynamic.DynamicSubject[]>>('dynamicSubjects', ref([]));
const dynamicVideo = computed(() =>
  dynamicVideos.value.length ? dynamicVideos.value[0] : null,
);

const rootRem = useRem();
const { height: windowHeight } = useWindowSize();
const videoHeight = computed(() => `${windowHeight.value - rootRem.value * 3}`);
const popupHeight = computed(() => `${windowHeight.value * 0.7}px`);

const textContent = computed(() => {
  let content = dynamicContent?.content || '';
  if (dynamicSubjects && dynamicSubjects.value) {
    dynamicSubjects.value.forEach((item) => {
      content = content.replace(item.displayName, '');
    });
  }
  return content;
});

const subjectsText = computed(() => {
  if (!dynamicSubjects.value) {
    return '';
  }
  return dynamicSubjects.value
    .map(
      (item) =>
        `<a class="subject-link" href="${import.meta.env.VITE_PROJECT_HTML_PATH}/media-subject.html?subjectId=${item.uuid}" target="_blank">${item.displayName}</a>`,
    )
    .join('');
});

const videoPlayerRef = ref();
const contentVisible = ref(false);
watch(
  () => contentVisible.value,
  (val) => {
    if (val) {
      videoPlayerRef.value.videoPlayer.height(windowHeight.value * 0.3);
    } else {
      videoPlayerRef.value.videoPlayer.height(videoHeight.value);
    }
  },
);
</script>

<style lang="scss" scopde>
.video-detail {
  .van-popup {
    @apply max-w-screen-sm bg-transparent;

    .author-box {
      width: 2rem;
      height: 1.1rem;
      font-size: 0.75rem;
      line-height: 1.1rem;
      color: #83c4ea;
      text-align: center;
      border: 1px solid #83c4ea;
      border-radius: 4px 1px;
    }
  }

  @media screen and (width >= 640px) {
    .van-popup {
      left: calc(50% - 320px);
    }
  }
}
</style>
